export function convertSecondsToMinutes(seconds: number) {
    return Math.floor(seconds / 60)
}
